import { RESOURCE_FILTER_ICON_MAP } from "@modules/for-you/constants.web";
import { RESOURCE_FILTER_LABEL_NAMES } from "@modules/for-you/types";
import { FC } from "react";

const FilterOptionLabel: FC<{ label: RESOURCE_FILTER_LABEL_NAMES }> = (
  props
) => {
  const IconComponent = RESOURCE_FILTER_ICON_MAP[props.label];
  return (
    <div className="flex items-center justify-center gap-2">
      <IconComponent />
      <span className="whitespace-nowrap">{props.label}</span>
    </div>
  );
};

export default FilterOptionLabel;
